import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { SettingInfoItem } from "@/features/user-setting/components/setting-info/SettingInfoItem";
import { TGetUserSettingOutputDto } from "@/features/user-setting/dtos/get-user-setting.dto";
import { AppRoutes } from "@/routes/config";
import { black, divider } from "@/theme/colors";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";

type TAccountInfoProps = {
  user: TGetUserSettingOutputDto;
};

export const AccountInfo: FC<TAccountInfoProps> = ({ user }) => {
  return (
    <InnerBox padding={3} showDivider={false} borderColor={divider.high}>
      <Stack alignItems="flex-start">
        <Typography variant="sub16Bold" color={black[30]}>
          アカウント情報
        </Typography>
        <Grid container columnSpacing="20px">
          <Grid item xs={4}>
            <SettingInfoItem label="部署" value={user.userDepartment ?? ""} isShowDivider={false} />
          </Grid>
          <Grid item xs={4}>
            <SettingInfoItem label="役職" value={user.userPosition} isShowDivider={false} />
          </Grid>
          <Grid item xs={4}>
            <SettingInfoItem label="紹介事業所" value={user.matchOfficeName ?? ""} isShowDivider={false} />
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
